export default "__VITE_ASSET__BPnc_w84__"